import { createContext, useContext, useState } from "react";
const TestModeContext=createContext()
export const TestModeContextProvider=({children})=>{
    const[testTime,settestTime]=useState(15)
    const values ={
        testTime,
        settestTime
    }

    return (<TestModeContext.Provider value={values}>{children}</TestModeContext.Provider>)
}
export const useTestMode =()=>useContext(TestModeContext)